import { createFileRoute } from '@tanstack/react-router';
import { PortalActivities } from '@/features/portal/PortalActivities';

/**
 * `?commessa=` è l'atterraggio dalla scheda della commessa. Sta nell'URL e non in uno
 * stato condiviso perché così il collegamento si può salvare e rimandare: «guarda le
 * attività di questa commessa» è un link, non una serie di istruzioni.
 */
export const Route = createFileRoute('/_portal/portal/attivita')({
  validateSearch: (s: Record<string, unknown>): { project?: string } => ({
    project: typeof s.commessa === 'string' && s.commessa ? s.commessa : undefined,
  }),
  component: PortalActivities,
});
